import types from './actionTypes';
import initialFilters from '../../../config/filters';
import { addOrReplaceObjectInArray } from '../../../helpers/reducerHelper';

const initialState = {
  loading: false,
  weeklyPushNotifications: [],
  filters: { ...initialFilters },
  error: '',
};

const weeklyPushNotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_WEEKLY_PUSH_NOTIFICATION_STATE:
      return initialState;
    case types.CREATE_WEEKLY_PUSH_NOTIFICATION.REQUEST:
    case types.FETCH_WEEKLY_PUSH_NOTIFICATIONS.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.CREATE_WEEKLY_PUSH_NOTIFICATION.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        weeklyPushNotifications: [
          ...state.weeklyPushNotifications,
          action.weeklyPushNotification,
        ],
      };
    case types.UPDATE_WEEKLY_PUSH_NOTIFICATION.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        weeklyPushNotifications: addOrReplaceObjectInArray(
          state.weeklyPushNotifications,
          action.weeklyPushNotification,
          'id',
          'merge',
        ),
      };
    case types.FETCH_WEEKLY_PUSH_NOTIFICATIONS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        weeklyPushNotifications: action.weeklyPushNotifications,
        filters: { ...action.filters },
      };
    case types.CREATE_WEEKLY_PUSH_NOTIFICATION.FAILURE:
    case types.UPDATE_WEEKLY_PUSH_NOTIFICATION.FAILURE:
    case types.FETCH_WEEKLY_PUSH_NOTIFICATIONS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default weeklyPushNotificationReducer;
